$(document).ready(function() {
    $('.js-game-filters').on('click', function() {
        $('.js-filters-modal').show();
        $('body').addClass('fixedPosition');
    });
    $('.js-game-filters-close').on('click', function() {
        $('.js-filters-modal').hide();
        $('body').removeClass('fixedPosition');
    });
});


// WEBPACK FOOTER //
// ./src/js/pages/game-index/game-filters.js